export default "__VITE_ASSET__2f05d285__"